import React from "react";
import EstimateProductsControl from "./EstimateProductsControl";

export default function EEOptionalItemsControl() {
    return <div>
        <EstimateProductsControl showCompareMaterialOptions={false}/>
    </div>;
}